import React, {useEffect, useRef, useState} from 'react';
import './index.css';
import {Trans} from 'react-i18next';
import {Form, Field, Formik} from 'formik';
import _get from 'lodash/get';
import ToggleEnableField from '../../components/togglernablefield';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import Header from '../../components/header';
import ButtonWithRestoreGroup from '../../../../components/formik/ButtonWithRestoreGroup';
import {
  getTemplate,
  getBrandId,
  getTemplateDefaultConfig,
  mappingDisable,
  arrayMapping,
  updateTemplate,
  treatmentTypes,
  facialZones,
} from '../../../../utils/skincareUtils';
import Loader from '../../../../components/spinner/Loader';
import utils from '../../../../utils/smbUtils';
import SkincareSimulationPreview from './preview';
import {multipleSubscriptionsUtils} from '../../../../utils/solutionUtils';
import _isEmpty from 'lodash/isEmpty';
import useWindowWidth from '../../../../components/hook/useWindowWidth';
import PublishToOnlineModal from '../components/PublishToOnlineModal';
import smbUtils from '../../../../utils/smbUtils';
import {history} from '../../../../utils/redux/store';
import {privilegeUtils} from '../../../../utils/privilegeUtils';
import ProcessingInProgressModal from '../components/ProcessingInProgressModal';
import { isFunctionBusyError } from '../../../../utils/errorUtils';

export default function SimulationPage() {
  const [initValue, setInitValue] = useState({});
  const width = useWindowWidth();
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {
    AESTHETIC_SIMULATION: {isPremiumPlan, isEnterprisePlan, attrs},
  } = multipleSubscriptionsUtils.getSolutionInfos(auth);
  const {token, customerId} = utils.customerInfo(auth);
  const [revisionId, setRevisionId] = useState();
  const formRef = useRef();
  const [commonData, setCommonData] = useState({});
  const [templateId, setTemplateId] = useState('');
  const [publishStatus, setPublishStatus] = useState(false);
  const [isShowPublishModal, setIsShowPublishModal] = useState(false);
  const [isShowProcessingModal, setIsShowProcessingModal] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const treatments = {
    face: treatmentTypes.filter(r => r.type === 'face'),
    skin: treatmentTypes.filter(r => r.type === 'skin'),
    eyebrows: treatmentTypes.filter(r => r.type === 'eyebrows'),
    eyes: treatmentTypes.filter(r => r.type === 'eyes'),
    nose: treatmentTypes.filter(r => r.type === 'nose'),
    lips: treatmentTypes.filter(r => r.type === 'lips'),
  };
  let disableData = {};
  const handleRestore = mode => {
    getTemplateDefaultConfig(
      'SmbSimulationFacialTreatment',
      mode,
      2,
      customerId
    ).then(r => {
      if (r && r.templateMetadata) {
        let data = r.templateMetadata;
        setInitValue({
          ...data,
        });

        updateTemplate(
          token,
          customerId,
          templateId,
          'SmbSimulationFacialTreatment',
          data
        ).then(r => {
          setPublishStatus(!publishStatus);
          toast.success(
            <Trans i18nKey="c.f.simple.button.group.success">success</Trans>
          );
        });
      }
    });
  };

  useEffect(() => {
    if (smbUtils.isCnSite(auth)) {
      history.push('/skincare-pro/ui-configuration/overview');
    }
    getBrandId(token, customerId).then(res => {
      if (res && _get(res, 'facialTreatmentRvId', '')) {
        setRevisionId(_get(res, 'facialTreatmentRvId', ''));
      }
      if (res && _get(res, 'commonSettingRvId')) {
        getTemplate(
          token,
          customerId,
          _get(res, 'commonSettingRvId'),
          'CommonSetting'
        ).then(res => {
          if (res && res.configJson) {
            setCommonData(JSON.parse(res.configJson));
          }
        });
      }
    });
  }, []);

  const refreshData = () => {
    getTemplate(token, customerId, revisionId)
      .then(res => {
        if (res && res.metaDataJson) {
          setInitValue(JSON.parse(_get(res, 'metaDataJson', '')));
        }
        setTemplateId(_get(res, 'templateId', ''));
      })
      .then(() => setIsLoaded(false));
  };

  useEffect(() => {
    if (revisionId) {
      refreshData();
    }
  }, [revisionId]);

  const getInitValue = values => {
    const data = {
      facialZones: mappingDisable(_get(values, 'facialZones', []), facialZones),
      treatmentOptions: {
        face: mappingDisable(
          _get(values, 'treatmentOptions.face', []),
          treatments.face
        ),
        skin: mappingDisable(
          _get(values, 'treatmentOptions.skin', []),
          treatments.skin
        ),
        eyebrows: mappingDisable(
          _get(values, 'treatmentOptions.eyebrows', []),
          treatments.eyebrows
        ),
        eyes: mappingDisable(
          _get(values, 'treatmentOptions.eyes', []),
          treatments.eyes
        ),
        nose: mappingDisable(
          _get(values, 'treatmentOptions.nose', []),
          treatments.nose
        ),
        lips: mappingDisable(
          _get(values, 'treatmentOptions.lips', []),
          treatments.lips
        ),
      },
    };
    getDisableData(data);
    return data;
  };

  const getDisableData = data => {
    if (isEnterprisePlan && !_isEmpty(attrs)) {
      const enableTreatmentData = JSON.parse(attrs);
      if (enableTreatmentData.length > 0) {
        const enableTreatmentData = JSON.parse(attrs);
        const enableFacial = enableTreatmentData.map(r => r.type);
        const findDisabled = facialZones.map(zone => {
          if (enableFacial.includes(zone.value)) {
            return {
              [zone.value]: _get(data.treatmentOptions, zone.value, [])
                .map(r => r.value)
                .filter(
                  r =>
                    !enableTreatmentData
                      .find(d => d.type === zone.value)
                      .items.includes(r)
                ),
            };
          }
          return {[zone.value]: _get(treatments, zone.value).map(r => r.value)};
        });

        disableData = {
          facialZones: _get(data, 'facialZones', [])
            .filter(r => !enableFacial.includes(r.value))
            .map(r => r.value),
          treatments: {
            ...findDisabled.reduce((d, c) => {
              d[Object.keys(c)] = c[Object.keys(c)];
              return d;
            }),
          },
        };
      }
    } else if (!isPremiumPlan) {
      disableData = {
        facialZones: facialZones.filter(r => r.isPremium).map(r => r.value),
        treatments: {
          face: [],
          eyebrows: [],
          lips: [],
          eyes: treatments.eyes.map(r => r.value),
          skin: treatments.skin.map(r => r.value),
          nose: treatments.nose.map(r => r.value),
        },
      };
    }
  };

  const formikConfig = {
    enableReinitialize: true,
    initialValues: getInitValue(initValue),
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true);
      const data = {
        facialZones: arrayMapping(values.facialZones),
        treatmentOptions: {
          face: arrayMapping(values.treatmentOptions.face),
          skin: arrayMapping(values.treatmentOptions.skin),
          eyebrows: arrayMapping(values.treatmentOptions.eyebrows),
          eyes: arrayMapping(values.treatmentOptions.eyes),
          nose: arrayMapping(values.treatmentOptions.nose),
          lips: arrayMapping(values.treatmentOptions.lips),
        },
      };
      await updateTemplate(
        token,
        customerId,
        templateId,
        'SmbSimulationFacialTreatment',
        data
      )
        .then(r => {
          setInitValue({
            ...data,
          });
          setIsShowPublishModal(true);
        })
        .catch(e => {
          if (isFunctionBusyError(e)) {
            setIsShowProcessingModal(true);
            setSubmitting(false);
            return;
          }

          toast.error(
            <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
          );
          setSubmitting(false);
        });
    },
  };

  if (
    !(
      privilegeUtils.canUiConfig(auth) ||
      privilegeUtils.isTechnicalSupport(auth)
    )
  ) {
    history.push('/');
  }

  return isLoaded ? (
    <div>
      <Header />
      <Loader />
    </div>
  ) : (
    <Formik {...formikConfig} ref={formRef}>
      {formikProps => (
        <Form className="skincare-configuration-form">
          <Header publishStatus={publishStatus} dirty={formikProps.dirty} />
          <div className="skincare-configuration-layout">
            <div
              className="skincare-configuration-layout__left"
              style={{width: width < 1366 && width > 768 && '55%'}}
            >
              <div className="kt-portlet skincare-configuration-layout__left-portlet">
                <div className="kt-portlet__body skincare-configuration-layout__left-portlet__body">
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.simulationpage.facial.zones">
                      Facial Zones
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <div className="text-dark">
                    <Trans i18nKey="p.s.uiconfiguration.simulationpage.facial.zones.desc">
                      Select which facial zones to enable for simulation and
                      sort orders for them. At least 1 option should be enabled.
                    </Trans>
                  </div>
                  <Field name="facialZones">
                    {props => (
                      <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
                        <div className="col-md-12">
                          <ToggleEnableField
                            itemList={_get(formikProps, 'values.facialZones')}
                            onChange={list => {
                              props.form.setFieldValue(props.field.name, list);
                            }}
                            disableItems={_get(disableData, 'facialZones', [])}
                            minEnable={1}
                            isEnterprise={isEnterprisePlan}
                            type={'AESTHETIC_SIMULATION'}
                          />
                        </div>
                      </div>
                    )}
                  </Field>
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.simulationpage.treatment.options">
                      Simulation Treatment Options
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <div className="text-dark">
                    <Trans i18nKey="p.s.uiconfiguration.simulationpage.treatment.options.desc">
                      Select which Simulation Treatments to enable and sort
                      orders for them. At least 1 option should be enabled for
                      each facial zone.
                    </Trans>
                  </div>
                  {_get(formikProps, 'values.facialZones', []).length > 0 &&
                    _get(formikProps, 'values.facialZones', []).map(
                      zone =>
                        !zone.disabled && (
                          <>
                            <div className="kt-margin-t-20">
                              <h5>{zone.label}</h5>
                            </div>
                            <Field name={`treatmentOptions.${zone.value}`}>
                              {props => (
                                <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
                                  <div className="col-md-12">
                                    <ToggleEnableField
                                      itemList={_get(
                                        formikProps,
                                        `values.treatmentOptions.${zone.value}`
                                      )}
                                      disableItems={_get(
                                        disableData,
                                        `treatments.${zone.value}`,
                                        []
                                      )}
                                      onChange={list => {
                                        props.form.setFieldValue(
                                          props.field.name,
                                          list
                                        );
                                      }}
                                      minEnable={1}
                                      type={'AESTHETIC_SIMULATION'}
                                    />
                                  </div>
                                </div>
                              )}
                            </Field>
                          </>
                        )
                    )}
                </div>

                <div className="d-flex justify-content-end kt-margin-t-20">
                  <ButtonWithRestoreGroup
                    saveDirty={formikProps.dirty}
                    discardButton={false}
                    isUpdating={true}
                    onRestoreClick={() => {
                      handleRestore(isPremiumPlan ? 'Premium' : 'Essential');
                      formikProps.resetForm();
                    }}
                  />
                </div>
              </div>
            </div>
            {!isLoaded && (
              <div
                className="skincare-configuration-layout__right"
                style={{width: width < 1366 && width > 768 && '45%'}}
              >
                {formikProps.values && (
                  <SkincareSimulationPreview
                    config={formikProps.values}
                    commonData={commonData}
                    isPremiumPlan={isPremiumPlan}
                  />
                )}
              </div>
            )}
          </div>
          <PublishToOnlineModal
            isShow={isShowPublishModal}
            onPublish={isPublish => {
              formikProps.setSubmitting(false);
              setPublishStatus(isPublish);
              setIsShowPublishModal(false);
            }}
          />
          <ProcessingInProgressModal
            show={isShowProcessingModal}
            onHide={() => {
              setIsShowProcessingModal(false);
            }}
          />
        </Form>
      )}
    </Formik>
  );
}
